module.exports = __webpack_public_path__ + "static/media/blue-ttc-logo.ec82f41d.svg";